import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

export const CompactTableInfoRow = ({ label, value }: { label: ReactNode; value: ReactNode }) => {
  return (
    <div css={styles.infoRow}>
      {typeof label === 'string' ? <Text color='subdued'>{label}</Text> : label}
      {typeof value === 'string' ? <Text textAlign='right'>{value}</Text> : value}
    </div>
  );
};

const styles = {
  infoRow: css`
    display: flex;
    justify-content: space-between;
    gap: ${theme.spacing(2)};
  `,
};
